"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BERNIE_CORE_EVENTS = void 0;
var bernie_logger_1 = require("bernie-logger");
exports.BERNIE_CORE_EVENTS = {
    LOG_EXPERIMENT_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'LOG_EXPERIMENT_ERROR'),
    MERGE_OMNITURE_DATA_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'MERGE_OMNITURE_DATA_ERROR'),
    PAGE_NAMESPACE_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'PAGE_NAMESPACE_ERROR'),
    PAGE_OMNITURE_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'PAGE_OMNITURE_ERROR'),
    PUBLISH_ANALYTICS_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'PUBLISH_ANALYTICS_ERROR'),
    TRACK_EVENT_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'TRACK_EVENT_ERROR'),
    REACT_ROUTE_ERROR: new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.CRITICAL, 'REACT_ROUTE_ERROR')
};
//# sourceMappingURL=bernie-core-events.js.map